import { Injectable } from '@angular/core';
import { combineLatest, Observable, of, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SharedSettings } from '../models/shared-settings';
import { Cacheable } from 'ts-cacheable';
import { User } from '../models/user';
import { url } from "@shared/helpers/url";

@Injectable({
    providedIn: 'root'
})
export class UsersService {
    private static readonly cacheBuster = new Subject<void>();

    constructor(
        private http: HttpClient,
        private settings: SharedSettings) {
    }

    @Cacheable({
        maxAge: 5 * 1000 * 60,
        cacheBusterObserver: UsersService.cacheBuster
    })
    GetUsers(): Observable<User[]> {
        return this.http.get<User[]>(this.settings.apiBaseUrl + 'users');
    }

    ImpersonateUser(userId: string): Observable<User> {
        return this.http.post<User>(this.settings.apiBaseUrl + url`users/impersonation`, JSON.stringify(userId), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    CancelImpersonateUser() {
        return this.http.delete(this.settings.apiBaseUrl + url`users/impersonation`);
    }
}
